import styled from 'styled-components';
import MoreHorizontalSolid from '@simplywallst/ui-core/icons/MoreHorizontalSolid';

export const MoreIcon = styled(MoreHorizontalSolid)`
  opacity: 1 !important;
  path {
    fill: ${({ theme }) => theme.color.spaceGray};
  }
`;
